import DOMPurify from 'dompurify';

// Strict allowlist: only typographic tags and safe anchors. No <script>,
// <iframe>, <object>, <embed>, <style>, <form>, inline event handlers, or
// `javascript:`/`data:` URIs. If a caller ever needs a new tag it must be
// added here deliberately so the allowlist stays auditable.
const SANITIZE_CONFIG = {
  ALLOWED_TAGS: [
    'a', 'b', 'br', 'code', 'div', 'em', 'i', 'img', 'li', 'ol', 'p', 'pre',
    'span', 'strong', 'sub', 'sup', 'u', 'ul',
    'h1', 'h2', 'h3', 'h4', 'h5', 'h6',
    'blockquote', 'hr', 'table', 'thead', 'tbody', 'tr', 'td', 'th'
  ],
  ALLOWED_ATTR: [
    'href', 'title', 'target', 'rel', 'class', 'id', 'lang', 'dir',
    'src', 'alt', 'width', 'height', 'loading'
  ],
  ALLOWED_URI_REGEXP: /^(?:https?:|mailto:|tel:|#|\/)/i,
  FORBID_ATTR: ['style', 'onerror', 'onload', 'onclick', 'formaction'],
  RETURN_TRUSTED_TYPE: false
};

export default function renderHtml(html) {
  return (
    <span dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(html || '', SANITIZE_CONFIG) }} />
  );
}
